(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sk8cult-delivery"] && !Shopify.designMode) return;
  try {
    class Sk8cultDelivery extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-delivery-input]');
      this.error = this.querySelector('[data-delivery-error]');
      this.abortController = null;
      this.saveTimeout = null;
      this.handleInput = this.handleInput.bind(this);

      if (!(this.input instanceof HTMLInputElement)) return;

      this.input.addEventListener('input', this.handleInput);
      this.setValidity(this.input.value.trim().length > 0);
    }

    disconnectedCallback() {
      this.input?.removeEventListener('input', this.handleInput);
      this.abortController?.abort();
      window.clearTimeout(this.saveTimeout);
      queueMicrotask(() => Sk8cultDelivery.syncCheckout());
    }

    handleInput() {
      if (!(this.input instanceof HTMLInputElement)) return;

      window.clearTimeout(this.saveTimeout);
      this.abortController?.abort();
      this.hideError();
      this.setValidity(false);

      this.saveTimeout = window.setTimeout(() => this.saveNote(), 350);
    }

    async saveNote() {
      if (!(this.input instanceof HTMLInputElement)) return;

      const deliveryValue = this.input.value.trim();
      const note = deliveryValue ? `${this.dataset.notePrefix || ''}${deliveryValue}` : '';
      this.abortController = new AbortController();

      try {
        const response = await fetch(Theme.routes.cart_update_url, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ note }),
          signal: this.abortController.signal,
        });

        if (!response.ok) throw new Error('Unable to save delivery note');

        this.setValidity(deliveryValue.length > 0);
      } catch (error) {
        if (error instanceof Error && error.name === 'AbortError') return;
        this.showError();
        this.setValidity(false);
      }
    }

    setValidity(isValid) {
      this.dataset.valid = isValid ? 'true' : 'false';
      this.input?.setAttribute('aria-invalid', isValid ? 'false' : 'true');
      Sk8cultDelivery.syncCheckout();
    }

    showError() {
      if (this.error instanceof HTMLElement) this.error.hidden = false;
    }

    hideError() {
      if (this.error instanceof HTMLElement) this.error.hidden = true;
    }

    static syncCheckout() {
      const fields = Array.from(document.querySelectorAll('sk8cult-delivery'));
      const checkoutEnabled = fields.length === 0 || fields.every((field) => field.dataset.valid === 'true');

      document.querySelectorAll('.cart__checkout-button').forEach((button) => {
        if (!(button instanceof HTMLButtonElement)) return;
        button.disabled = !checkoutEnabled;
        button.setAttribute('aria-disabled', checkoutEnabled ? 'false' : 'true');
      });

      document.querySelectorAll('.additional-checkout-buttons').forEach((buttons) => {
        buttons.setAttribute('aria-disabled', checkoutEnabled ? 'false' : 'true');
      });
    }
  }

  if (!customElements.get('sk8cult-delivery')) {
    customElements.define('sk8cult-delivery', Sk8cultDelivery);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sk8cult-wishlist"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.sk8cult-wishlist__message').forEach((message) => {
    message.closest('.sk8cult-wishlist__details')?.setAttribute('open', '');
  });
  } catch(e) { console.error(e); }
})();

})();
